/* 国际化 */
import { ConfigProvider, App } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import "dayjs/locale/zh-cn";
import RouterAuth from "./pages/routerAuth";
import "./App.scss";
import "./style/zoom.scss";
import "./style/common.scss";
import { zoomInit } from "./utils/zoom";
import { useLayoutEffect, createContext, useMemo } from "react";

import { useGoodsOpenModal, AppContext } from "./hooks/useGoodsOpenModal";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider as ReduxProvider } from "react-redux";
const { Provider } = AppContext;
function AppRoot() {
	useLayoutEffect(() => {
		zoomInit();
	}, []);
	const {
		openGoodsItem,
		updateGoodsItem,
		openConfirmOrder,
		updateOpenConfirmOrder,
		openOrderDetail,
		updateOpenOrderDetail
	} = useGoodsOpenModal();
	return (
		<ReduxProvider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<Provider
					value={{
						openGoodsItem,
						updateGoodsItem,
						openConfirmOrder,
						updateOpenConfirmOrder,
						openOrderDetail,
						updateOpenOrderDetail
					}}
				>
					<ConfigProvider
						locale={zhCN}
						theme={{
							token: {
								colorPrimary: "#2541F7",
								borderRadius: 4,
								colorBorder: "#eaeffc"
								// colorBgBase: "#f3f7fc"
							},
							components: {
								Tabs: {
									horizontalItemPaddingLG: "0 0 16px"
								},
								Message: {
									maxCount: 1
								},
								Menu: {
									itemBorderRadius: 0
								},
								Table: {
									headerBg: "#f3f7fc"
								}
							}
						}}
					>
						<App message={{ maxCount: 1 }} style={{ height: "100%" }}>
							<>{RouterAuth()}</>
						</App>
					</ConfigProvider>
				</Provider>
			</PersistGate>
		</ReduxProvider>
	);
}

export default AppRoot;
